export default "__VITE_ASSET__Dbu1$vf9__"